import type { FaireProductEntity } from "../../entity_types/product";

export const p_bc4csa4y6f: FaireProductEntity = {
  token: "p_bc4csa4y6f",
  type: "product",
  name: "LM-SK-1000 BUBBLE SKIRT - WHITE CAMO",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/26ccaae9ce9ed037e55cf6b1c110a6f4d2a8498969ed63ae33fa83cfacaabad2.jpeg",
  galleryImageUrls: [],
  priceDollars: 17.5,
  description: "This lightweight bubble skirt from Girlie Girl Originals features a white camo pattern and offers a playful bubble shape suitable for casual or dressed-up looks. Designed for comfortable wear, it can be styled with t-shirts or blouses to add character to a wardrobe. A versatile piece for retailers seeking bold, southern‑inspired apparel.",
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:33.160Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
